import React, {useEffect} from 'react';
import { KoFormBuilder, KoSelect, KoTextArea } from 'packages';
import styles from './curd.module.scss';

function GeneralInfoCrud({ form, product }) {


  useEffect(()=>{
    form?.resetFields();
  },[]);

  const TextArea = ({ value, onChange }) => (
    <KoTextArea value={value} onChange={onChange} showCount
      maxLength={100}/>
  );

  const Category = ({ value, onChange }) =>
    <KoSelect
      placeholder="Select Category"
      value={value}
      onChange={v => onChange(v)}
      options={[{
        name:'USD', value:'usd'
      }].map((module) => ({
        label: module?.name,
        value: module?.value
      }))}
    />;


  const meta = {
    columns: 4,
    formItemLayout: null,
    initialValues: product,
    colon: true,
    fields: [
      {
        key: 'name', label: 'Product Name' , placeholder: 'Ex: apple', colSpan: 4,
        rules: [
          {
            required: true,
            message: 'Product name is required'
          }
        ]
      },
     
      {
        key: 'description', label: 'Description', placeholder: 'Type product description here. . .', colSpan: 4,  widget: TextArea
      },
      {
        key: 'label1',
        colSpan: 4,
        render() {
          return (
            <fieldset>
              <legend>CATEGORY</legend>
            </fieldset>
          );
        }
      },
      {
        key: 'category', label: 'Product Category', colSpan: 2, widget: Category,
        rules: [
          {
            required: true,
            message: 'Category is required'
          }
        ]
      },
      {
        key: 'tags', label: 'Product Tags', colSpan: 2, widget: Category
       
      }
    ]
  };
  return (
    <div className={styles.wrapper}>
      <KoFormBuilder form={form} meta={meta} />
    </div>
  );
};

export default GeneralInfoCrud;